import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import React from "react";
import { useAlert } from "./../alerts//AlertContext";
import { Link } from "react-router-dom";
import TaskEditDialog from "./TaskEditDialog";
import TaskActivity from "./TaskActivity";
import TaskComments from "./TaskComments";

function TaskEditMenu({ taskId, statusId }) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("1");
  const showAlert = useAlert();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const onClickTaskHandler = (e) => {
    setOpen(true);
    e.preventDefault(); // Stop navigation if validation fails
  };

  return (
    <React.Fragment>
      <Link to={`/editTask/${taskId}`} onClick={onClickTaskHandler}>
        {taskId}
      </Link>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 800, // fixed width
            height: 570, // fixed height
            maxWidth: "100%", // optional for responsiveness
            maxHeight: "100%", // optional to prevent overflow
          },
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();

            // saveUser();
            handleClose();
          },
        }}
      >
        <DialogTitle>{taskId}</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ "& .MuiTextField-root": { m: 1 } }}
            noValidate
            autoComplete="off"
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange} aria-label="Org's">
                  <Tab label="Details" value="1" />
                  <Tab label="Activity" value="2" />
                  <Tab label="Comments" value="3" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: "20px 0px" }}>
                <TaskEditDialog taskId={taskId} statusId={statusId} />
              </TabPanel>
              <TabPanel value="2" sx={{ padding: "20px 0px" }}>
                <TaskActivity taskId={taskId} />
              </TabPanel>
              <TabPanel value="3" sx={{ padding: "20px 0px" }}>
                <TaskComments taskId={taskId} />
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
export default TaskEditMenu;
